export default "__VITE_ASSET__18FWY09C__"